import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { OutputAnalyticsKey } from '@portal-core/output-analytics/models/output-analytics-key.model';

@CollectionStateSelectors({
  stateType: OutputAnalyticsKeyState
})
@State<OutputAnalyticsKeyState>({
  name: OutputAnalyticsKeyState.source,
})
@Service({ autoProvided: false })
export class OutputAnalyticsKeyState extends CollectionStateBase {
  static override source = 'OutputAnalyticsKeys';
  getSource(): string {
    return OutputAnalyticsKeyState.source;
  }
}

@Service()
export class OutputAnalyticsKeyDataService extends CollectionDataServiceBase<OutputAnalyticsKey> {
  protected readonly stateType = OutputAnalyticsKeyState;
}
